import { useQuery } from '@apollo/client/react'
import { useMemo } from 'react'

import { MyCirclesDocument, MyCirclesQuery } from '@/graphql/api/generated'

type MyCircleNode = NonNullable<
  NonNullable<NonNullable<MyCirclesQuery['myCircles']>['edges']>[number]['node']
>

/**
 * Returns the current user's circles indexed by their IRI (node.id, e.g. /circles/{slug}) for
 * O(1) lookups. Shares the MyCircles query (cache-first) with the ContextSwitcher, and the Map
 * is memoized so consumers don't rescan the list on every render.
 */
export function useMyCirclesMap(skip = false): Map<string, MyCircleNode> {
  const { data } = useQuery<MyCirclesQuery>(MyCirclesDocument, {
    skip,
    fetchPolicy: 'cache-first',
  })

  return useMemo(() => {
    const map = new Map<string, MyCircleNode>()
    for (const edge of data?.myCircles?.edges ?? []) {
      const node = edge?.node
      if (node?.id) {
        map.set(node.id, node)
      }
    }
    return map
  }, [data?.myCircles?.edges])
}
